import React from 'react';
import { TableHeader } from '../TableHeader/TableHeader';
import { TableBody, TableWrapper } from '../../../../../../CommonComponents/OPL/Table/Table';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';

interface Props {
  openLinkAccountModal(): void;
  onBack(): void;
  canLinkAccount: boolean;
}

export const ModalWrapper: React.FC<Props> = ({
  canLinkAccount,
  children,
  openLinkAccountModal,
  onBack,
}) => {
  return (
    <>
      <Box display="flex" flexDirection="column" flex={1} justifyContent="space-between">
        <TableWrapper variant="embedded">
          <TableHeader />
          <TableBody>{children}</TableBody>
        </TableWrapper>

        {canLinkAccount && (
          <Box
            display="flex"
            justifyContent="center"
            borderWidth="1px 0 1px 0"
            borderStyle="solid"
            borderColor="neutral.200"
          >
            <Button
              my="16"
              leftIcon="fas fa-plus"
              variant="subtleActive"
              onClick={openLinkAccountModal}
            >
              Link New Account
            </Button>
          </Box>
        )}
      </Box>

      <ModalFooter>
        <Button leftIcon="fas fa-chevron-left" variant="secondary" onClick={onBack} mr="auto">
          Back
        </Button>
      </ModalFooter>
    </>
  );
};
